import type { ReactNode } from 'react';
import { type Renderable, toast as RHToast } from 'react-hot-toast';

const getToastBody = (
  title: string | ReactNode,
  message: string | ReactNode,
): Renderable => {
  return (
    <div className="toaster-text-container">
      <p className="text-base semibold">{title}</p>
      <p className="text-sm regular">{message}</p>
    </div>
  );
};

const toast = (title: string | ReactNode, message: string | ReactNode) =>
  RHToast(getToastBody(title, message));

toast.success = (title: string | ReactNode, message: string | ReactNode) =>
  RHToast.success(getToastBody(title, message));

toast.error = (title: string | ReactNode, message: string | ReactNode) =>
  RHToast.error(getToastBody(title, message));

export { toast };
